// src/components/AboutMain.jsx
import React from 'react';
import './about-main.css';
import aboutImage from '../assets/images/about-us.jpg';

const AboutMain = () => {
  return (
    <section className="vanshika-about-section">
      <div className="vanshika-container">
        <div className="vanshika-row">
          {/* Image Column */}
          <div className="vanshika-col vanshika-img-col">
            <img
              src={aboutImage}
              alt="About Us"
              className="vanshika-about-img"
            />
          </div>

          {/* Content Column */}
          <div className="vanshika-col vanshika-content-col">
            <h2 className="vanshika-section-title">About us</h2>
            <p className="vanshika-lead">
              Money emergencies don’t wait. Neither do we.
            </p>
            <p className="vanshika-description">
              At Vanshika Micro Credit, we are revolutionizing borrowing in India by offering fast, simple, and hassle-free personal loans tailored for salaried individuals in urgent need. Our services eliminate paperwork, bias, and delays, delivering instant financial support when you need it most. We understand that awaiting your salary date is not an option when life demands urgent attention —be it medical expenses, overdue bills, or family responsibilities. Vanshika Micro Credit is your trusted partner, committed to providing transparent, compliant, and responsible lending solutions designed around your needs.
            </p>
            <ul className="vanshika-feature-list">
              <li>⚡Fast, reliable loan approval for urgent needs</li>
              <li>📲 Fully digital process—simple, secure, and convenient</li>
              <li>🔍 Transparent terms with clear, upfront disclosures</li>
              <li>🤝 Personalized service driven by empathy and integrity</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMain;
